import Masonry from 'masonry-layout';

if ($(".masonry-content").length) {
	let masonry = new Masonry($('.masonry-content .masonry').get(0), {
		itemSelector: '.projet',
		percentPosition: true,
		columnWidth: '.card3'

	});
}

if ($(".projets").length) {
	let options = {
		rootMargin: '0px',
		threshold: 1.0

	};

	let containerAtropos = document.querySelectorAll('.projet');

	let observer = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			entry.target.classList.add('animate__zoomIn')
			entry.target.classList.add('animate__faster')
			entry.target.classList.add('active')

		});
	}, options);

	containerAtropos.forEach(containerAtropos => observer.observe(containerAtropos));
}







